// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".small-sort-icon svg{height:10px!important}", "",{"version":3,"sources":["webpack://./resources/js/core/components/datatable/TableWithoutWrapper.vue"],"names":[],"mappings":"AAEI,qBACI,qBADR","sourcesContent":["\n.small-sort-icon {\n    svg {\n        height: 10px !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
